import * as $ from "jquery";
import { isMobile } from "./utility";

export class FacultyScoreReport {
    $modal: JQuery;
    $scoreimage: JQuery;

    /* ---- FOOTER ---- */
    constructor() {
        this.$modal = $("#facultyscorereport");
        this.$scoreimage = this.$modal.find("#scoreImage");
        const self = this;

        const $modelclose = this.$modal.find(".fa");
        const $modelmask = this.$modal.find(".mask");

        self.$scoreimage.on("load", function () {
            self.$scoreimage.css("visibility", "visible");
        });

        $modelclose.on("click", function () {
            self.$modal.hide();
        });
        $modelmask.on("click", function () {
            self.$modal.hide();
        });
    }

    addWatch() {
        const self = this;
        // Modals
        $(".scorereport").on("click", function () {
            const $srbutton = $(this);
            const src = $srbutton.data("scorereport");
            const name = <string> $srbutton.data("name");
            self.launchModal(src, name);
        });
    }

    launchModal(src: string, name: string) {
        // Opens image in new tab for mobile devices
        if (isMobile()) {
            window.open(src);
            return;
        }

        // Load image and name
        this.$scoreimage.css("visibility", "hidden").attr("src", src);
        this.$modal.find(".title h2").text(name);

        // Show modal
        this.$modal.fadeToggle(100);
        this.$modal.css("display", "flex");
    }
}
